export const university_articles = [
    {
        image_url: "https://www.columbiaspectator.com/resizer/v2/DHBQVGYOEZDHBLOOD37GONL2QU.png?auth=2aba86766e4aff052d229026b69a781f3146f01500c533651e7ade288c571395",
        article_title: "Student Afro-American Society alumni look to strengthen relationship with Harlem following years of activism",
        article_authors: "Aiyana St. Hilaire",
        article_link: "https://www.columbiaspectator.com/news/2025/02/11/student-afro-american-society-alumni-look-to-strengthen-relationship-with-harlem-following-years-of-activism/"
    },
    {
        image_url: "https://www.columbiaspectator.com/resizer/v2/TCO2LZ2LMBEB7AY6E25INPURLU.jpg?auth=5c56d2da11efd2f04040032881f99b3032e48c7e50913389e21e0509011e0af3",
        article_title: "Undergraduate Community Initiative launches spring programming with a tribute to Martin Luther King Jr.",
        article_authors: "Daniela Ospino Pallares",
        article_link: "https://www.columbiaspectator.com/news/2025/02/05/undergraduate-community-initiative-launches-spring-programming-with-a-tribute-to-martin-luther-king-jr/"
    },
    {
        image_url: "https://www.columbiaspectator.com/resizer/v2/GYRGD75TEZF3LLRKICN7MSWTO4.jpg?auth=124fb0e5563ed11f3061e9a2c25f8fef3a954b45ed93e46b2dd606dfb140a304",
        article_title: "‘More important now than it was ever before’: Organizers reflect on the Black Student Orientation Program one semester later",
        article_authors: "Wiann Wilson",
        article_link: "https://www.columbiaspectator.com/news/2025/02/10/more-important-now-than-it-was-ever-before-organizers-reflect-on-the-black-student-orientation-program-one-semester-later/"
    },
    {
        image_url: "https://cloudfront-us-east-1.images.arcpublishing.com/spectator/72QTI6S5OBEQLBXBXOGKYSKCDM.png",
        article_title: "A history of affirmative action at Columbia and Barnard",
        article_authors: "Wiann Wilson",
        article_link: "https://www.columbiaspectator.com/news/2025/02/12/a-history-of-affirmative-action-at-columbia-and-barnard/"
    },
    {
        image_url: "https://cloudfront-us-east-1.images.arcpublishing.com/spectator/2NRH55FB3VH4FGWEXDTQAIJTAY.gif",
        article_title: "Four years ago, Literature Humanities students read five Black authors. Now, they read two.",
        article_authors: "Tulasi Cherukuri and Ria Vashishtha",
        article_link: "https://www.columbiaspectator.com/news/2025/02/13/four-years-ago-literature-humanities-students-read-five-black-authors-now-they-read-two/"
    },
    {
        image_url: "https://www.youtube.com/watch?v=2g4BYaDYSRE",
        article_title: "The return of Columbia's Gospel Choir",
        article_authors:"Tasneem Meem, Jordan Pettiford, Hanan Ali, Ashlynne Graham, and Elliot Heath",
        article_link:"https://www.youtube.com/watch?v=2g4BYaDYSRE"
    }
];